import React from 'react';

/**
 * Inline spinner for buttons, tables, etc. Reuse across modules.
 */
export default function LoaderSpinner({ size = 18, className = '', style = {} }) {
  return (
    <i
      className={`ti ti-loader shm-loader-spin ${className}`.trim()}
      style={{ fontSize: size, ...style }}
      aria-hidden
    />
  );
}
